import Grid from '@mui/material/Grid';
import { User } from '@sentry/react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import useUserManagement from '../../../data-access/hooks/useUserManagement';
import CompanyDetails from './CompanyDetails';
import Complete from './OnboardingComplete';
import Welcome from './OnboardingWelcome';
import PersonalDetails from './PersonalDetails';
const OnboardPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step') || 'welcome';

  const userManagement = useUserManagement();
  const { user, fetchUser } = userManagement;

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const renderStep = (user: User) => {
    switch (step) {
      case 'welcome':
        return <Welcome firstName={user.firstName} />;
      case 'company-details':
        return <CompanyDetails organizationId={user.organizationId} />;
      case 'personal-details':
        return <PersonalDetails useUserManagement={userManagement} />;
      case 'complete':
        return <Complete />;
      default:
        return <Welcome firstName={user?.firstName ?? ''} />;
    }
  };

  return <Grid container>{user && renderStep(user)}</Grid>;
};

export default OnboardPage;
